export enum MappedKeyword {
	PHD = 'phd',
	MASTERS = 'masters',
	BACHELORS = 'bachelors',
	ENGLISH = 'english',
}
